import { render, staticRenderFns } from "./ViewComplaints.vue?vue&type=template&id=538ee641&scoped=true"
import script from "./ViewComplaints.vue?vue&type=script&lang=js"
export * from "./ViewComplaints.vue?vue&type=script&lang=js"
import style0 from "./ViewComplaints.vue?vue&type=style&index=0&id=538ee641&prod&scoped=true&lang=css"
import style1 from "./ViewComplaints.vue?vue&type=style&index=1&id=538ee641&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538ee641",
  null
  
)

export default component.exports